import React from 'react';

const referralCodesMetadata = [
  {
    Header: 'Users invited',
    id: 'email',
    accessor: 'referreeEmail',
    filterable: false,
  },
  {
    Header: 'Status',
    id: 'status',
    accessor: 'status',
    filterable: false,
    Cell: ({ original }) => (
      <p className="referral-table-status">{original.status}</p>
    ),
  },

  {
    Header: 'Earned',
    id: 'earned',
    accessor: 'referrerPayoutAmount',
    filterable: false,
    Cell: ({ original }) => (
      <p className="referral-table-earned">
        {`$ ${original.referrerPayoutAmount}`}
      </p>
    ),
  },
];
export default referralCodesMetadata;
